<template>
    <v-main>
        <v-container v-if="loading">
            <cardWait />
        </v-container>
        <v-container fluid class="relative ma-2" v-if="!loading">
            <v-row cols="12">
                <v-col cols="12" class="pr-6">
                    <cardVectorStores :stores="stores" @updateData="updateData"/>
                </v-col>
            </v-row>
            <v-row cols="12">
                <v-col cols="6" class="pr-6" v-for="store in stores" :key="store.id">
                    <cardVectorStore :store="store" @updateData="updateData"/>
                </v-col>
            </v-row>

        </v-container>
        <navbar title="ARES - OpenAI" type="openai" :home="true" @actionClick="actionClick" />
    </v-main>
</template>

<script>
    import navbar from '@/components/ui/navbars/navbar.vue';

    import cardWait from '@/components/syst/openai/cardWait.vue';
    import cardVectorStore from '@/components/syst/openai/cardVectorStore.vue';
    import cardVectorStores from '@/components/syst/openai/cardVectorStores.vue';


    export default {        
        components: {
            navbar,
            cardWait,
            cardVectorStore,
            cardVectorStores,
        },
        data() {
            return {
                loading: true,
                stores: [],
            }
        },
        mounted() {
            this.getVectorStores(false);
        },
        methods: {
            getVectorStores(refresh) {
                this.loading = true;
                this.$axios.post("ares/json/ares/syst/openai/getVectorStores.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getVectorStores"
                    },
                    getVectorStores: {
                        refresh: refresh,
                    },
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.stores = res.data.getVectorStores;
                        this.loading = false;
                    }
                });
            },
            // Dummy callback for navBar
            actionClick() {

            },           
            updateData(data) {
                switch (data) {
                    case "refresh":
                        this.getVectorStores(true);
                        break;
                    default:
                }
            },           
        },
    }
</script>

<style scoped>
</style>
